import { render, staticRenderFns } from "./EntityBlock.vue?vue&type=template&id=022024f9&scoped=true&"
import script from "./EntityBlock.vue?vue&type=script&lang=js&"
export * from "./EntityBlock.vue?vue&type=script&lang=js&"
import style0 from "./EntityBlock.vue?vue&type=style&index=0&id=022024f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022024f9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSwiperCarousel: require('/app/components/UI/UiSwiperCarousel.vue').default,UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
